import React from 'react';
import { getCurrentUser } from '@/services/ws-permissions/src/main/resources/rest-api';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { useNavigate } from '@/js/libs/router';
import { useLazyRequest } from '@/js/libs/use-request';
import { AuthContext } from '../../authContext';
import useTokenStorage from '../useTokenStorage';
export const useGetIdentity = ({ onSuccess, onFail, userParams = {} }) => {
    const { getAuthToken } = useTokenStorage();
    const { identity: { loading, initialized }, setIdentity, } = React.useContext(AuthContext);
    const navigate = useNavigate();
    const getCurrentUserRequest = useLazyRequest({
        apiMethod: getCurrentUser,
        onSuccess: ({ data: user }) => {
            onSuccess?.(user);
            setIdentity({
                user,
                loading: false,
                initialized: true,
            });
            if (initialized) {
                navigate('/');
            }
        },
        onFail: (error) => {
            setIdentity(({ user }) => ({
                user,
                loading: false,
                initialized: true,
            }));
            onFail?.(error);
        },
    });
    const getIdentity = useCallbackRef(() => {
        setIdentity((prevState) => ({
            ...prevState,
            loading: true,
        }));
        const accessToken = getAuthToken();
        if (!accessToken) {
            setIdentity({
                user: undefined,
                loading: false,
                initialized: true,
            });
            return Promise.resolve(undefined);
        }
        return getCurrentUserRequest.load(userParams).then((response) => response.data);
    });
    return React.useMemo(() => ({
        getIdentity,
        loading,
        initialized,
    }), [getIdentity, loading, initialized]);
};
